import app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
	apiKey: "AIzaSyAYqjYFHi8OnrLkwJ7nil_QzYL-nUXNh1g",
	authDomain: "jema-f48a1.firebaseapp.com",
	databaseURL: "https://jema-f48a1.firebaseio.com",
	projectId: "jema-f48a1",
	storageBucket: "jema-f48a1.appspot.com",
	messagingSenderId: "775053573681",
	appId: "1:775053573681:web:4ce767ff14d94211fa1f10",
	measurementId: "G-RY0TD2WERV",
};

class Firebase {
	constructor() {
		app.initializeApp(firebaseConfig);
		this.db = app.firestore();
		this.auth = app.auth();
	}

	login(email, password) {
		return this.auth.signInWithEmailAndPassword(email, password);
	}

	logout() {
		return this.auth.signOut();
	}

	estaIniciado() {
		return new Promise((resolve) => {
			this.auth.onAuthStateChanged(resolve);
		});
	}

	async getAdengamentos() {
		try {
			const agendamentos = [];
			const agendamentosDocs = await this.db
				.collection("agendamentos")
				.get();

			agendamentosDocs.forEach((doc) => {
				const agendamento = doc.data();
				if (agendamento.data !== "24/06")
					agendamentos.push(agendamento);
			});
			return agendamentos;
		} catch (error) {
			return [];
		}
	}

	async novoUsuario(nome, email, token) {
		try {
			await this.db.collection("usuarios").doc(email).set({
				nome,
				email,
				token,
			});
			return true;
		} catch (error) {
			return false;
		}
	}
	async novoHorario(hid, data, hora) {
		try {
			await this.db.collection("agendamentos").doc(hid).set({
				ativo: true,
				livre: true,
				data,
				hora,
				aid: hid
			});
			return true;
		} catch (error) {
			return false;
		}
	}


	async listarUsuarios() {
		const usuarios = [];
		const usuariosDocs = await this.db.collection("usuarios").get();
		usuariosDocs.forEach((doc) => {
			usuarios.push(doc.data());
		});
		return usuarios;
	}

	async agendar(docId, estudante, sala, email) {
		console.log(docId)
		this.db.collection("agendamentos").doc(docId).update({
			livre: false,
			estudante: estudante,
			sala: sala,
			email: email,
		}).then(() => true).catch(error => false);
	}

	async usuarioAgendado(emailDoUsuario) {
		try {
			console.log("consultando agendamento");
			const agendado = await this.db
				.collection("agendamentos")
				.where("email", "==", `${emailDoUsuario}`)
				.get();
			console.log(emailDoUsuario, agendado);
			return agendado.docs[0];
		} catch (error) {
			alert(error.message);
		}
	}

	async ativarAgendamento(agendamento) {
		try {
			await this.db
				.collection("agendamentos")
				.doc(agendamento.aid)
				.update({
					ativo: true,
				});
		} catch (error) {
			alert("algo deu errado");
		}
	}
	async desativarAgendamento(agendamento) {
		try {
			await this.db
				.collection("agendamentos")
				.doc(agendamento.aid)
				.update({
					ativo: false,
				});
		} catch (error) {
			alert("algo deu errado");
		}
	}

	async horariosDisponiveis(data) {
		const horarios = [];
		const agendamentosDocs = await this.db
			.collection("agendamentos")
			.where("data", "==", `${data}`)
			.where("ativo", "==", true)
			.where("livre", "==", true)
			.get();
		agendamentosDocs.forEach((doc) => {
			horarios.push(doc.data());
		});
		console.log(horarios)
		return horarios;
	}

	async consultarAgendamento() {
		const agendado = await this.db
			.collection("agendamentos")
			.where("capital", "==", true);
		console.log(agendado);
	}
}

export default new Firebase();
